module.exports = __webpack_public_path__ + "media/Video 122.61502fb5.mp4";